// Dates et heures affichées en français, dans le fuseau du foyer.

const FUSEAU_PAR_DEFAUT = 'Europe/Paris';

export function fuseauAppareil(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || FUSEAU_PAR_DEFAUT;
  } catch {
    return FUSEAU_PAR_DEFAUT;
  }
}

/** « 19 h 30 » (usage typographique français). */
export function heure(d: Date, fuseau = FUSEAU_PAR_DEFAUT): string {
  const [h, m] = new Intl.DateTimeFormat('fr-FR', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: fuseau,
  })
    .format(d)
    .split(':');
  return `${Number(h)} h ${m}`;
}

/** « 19:30 » du réglage → « 19 h 30 ». */
export function heureReglage(hhmm: string): string {
  const [h, m] = hhmm.split(':');
  return `${Number(h)} h ${m}`;
}

/** Date civile AAAA-MM-JJ → « jeudi 29 octobre ». */
export function dateLongue(civile: string): string {
  const [a, m, j] = civile.split('-').map(Number);
  return new Intl.DateTimeFormat('fr-FR', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    timeZone: 'UTC',
  }).format(new Date(Date.UTC(a!, m! - 1, j)));
}

/** Date civile AAAA-MM-JJ → « 16 octobre 2026 » (date d'une source). */
export function dateComplete(civile: string): string {
  const [a, m, j] = civile.split('-').map(Number);
  return new Intl.DateTimeFormat('fr-FR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(new Date(Date.UTC(a!, m! - 1, j)));
}

/** Date civile AAAA-MM-JJ → « jeu. 29/10 ». */
export function dateCourte(civile: string): string {
  const [a, m, j] = civile.split('-').map(Number);
  const jour = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', timeZone: 'UTC' }).format(
    new Date(Date.UTC(a!, m! - 1, j)),
  );
  return `${jour} ${String(j).padStart(2, '0')}/${String(m).padStart(2, '0')}`;
}

/** Date civile du jour dans un fuseau. */
export function aujourdhuiCivil(fuseau: string, maintenant = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: fuseau,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(maintenant);
}
